"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopMenu = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.TopMenu = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;

  height: 33px;
`;
//# sourceMappingURL=top-menu.js.map